<!--<section class="aarni-font text-justify">
    <div class="max-w-7xl mx-auto flex flex-col md:flex-row items-start gap-4 md:gap-8 px-4 py-16">
        <div class="md:w-2/4">
            <h2 class="text-2xl font-bold">OVERVIEW</h2>
            <p class="mt-4 text-gray-700">
                In the Year 2018, ARNI University established an Internal Quality Assurance Cell (IQAC). The vision of
                IQAC is to align with the University Grant Commission (UGC) and National Assessment and Accreditation
                Council (NAAC) guidelines and implement them for providing quality education. IQAC plays an important
                role in maintaining the university framework. It is delicately focused on promoting quality education
                enhancement and sustainability across all academic and administrative domains.
            </p>
            <p class="text-lg font-bold">Vision of IQAC at ARNI</p>
            <p class="text-gray-700">
                To encourage a diversified and dynamic environment that provides frequent improvement and excellence in
                administrative and academic performance.
            </p>
            <p class="text-lg font-bold">Mission of IQAC at ARNI</p>
            <p class="text-gray-700">
                To create, maintain, and implement strategies to ensure the best quality and enhancement. Our mission is
                to offer educational offerings that meet the highest standards of educational excellence on a global
                scale.
            </p>
        </div>

        <div class="md:w-2/4 p-2">
            <div class="mt-8">
                <img alt="iqac" src="assets/img/iqac.webp" class="w-full rounded-lg object-cover"/>
            </div>
        </div>
    </div>

    <div class="bg-gray-100 py-16">
        <h2 class="text-center text-2xl font-bold mb-6">Latest Achievements</h2>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-7xl mx-auto px-2">
            <div class="bg-white border-2 border-yellow-500 rounded-lg p-6 shadow-lg text-center">
                <img src="assets/img/iqac/iqac1.jpg" alt="QS I-Gauge Certificate" class="w-full h-[250px]">
                <p class="mt-4 font-semibold">Global Prestige Awards 2024</p>
            </div>

            <div class="bg-white border-2 border-yellow-500 rounded-lg p-6 shadow-lg text-center">
                <img src="assets/img/iqac/iqac2.jpg" alt="QS I-Gauge Certificate" class="w-full h-[250px]">
                <p class="mt-4 font-semibold">Education Excellence 2024</p>
            </div>

            <div class="bg-white border-2 border-yellow-500 rounded-lg p-6 shadow-lg text-center">
                <img src="assets/img/iqac/iqac3.jpg" alt="QS I-Gauge Certificate" class="w-full h-64">
                <p class="mt-4 font-semibold">4th NTPC -National Ranking Archery Tournament 2025</p>
            </div>
        </div>
    </div>

    <div class="max-w-6xl lg:mx-auto border-gray-200 border mx-3 p-4 my-8">
        <div class="space-y-4">
            <div *ngFor="let section of sections; let i = index">
                <button class="w-full flex items-center p-2" (click)="toggleAccordion(i)">
                    <i class="text-lg"
                       [ngClass]="activeIndex === i ? 'fas fa-minus text-blue-500' : 'fas fa-plus text-blue-500'"></i>
                    <span class="ml-2 font-bold text-lg md:text-xl">{{ section.heading }}</span>
                </button>
                <div *ngIf="activeIndex === i" class="p-2 text-gray-700 sm:text-sm text-justify"
                     [innerHTML]="section.content"></div>
                <hr *ngIf="i < sections.length - 1">
            </div>
        </div>
    </div>
</section>-->
<div class="relative w-full overflow-hidden aarni-font hidden md:block mt-[80px]">
    <img src="assets/img/iqac/internal-banner-iqac-desktop.webp" alt="Desktop Image"
         class="w-full h-auto object-contain">
    <div class="absolute top-[40%] left-[12%] m-4 text-white px-4 py-2 rounded text-6xl font-bold">
        <p>INTERNAL QUALITY</p>
        <p>ASSURANCE CELL</p>
    </div>
</div>
<div class="relative w-full overflow-hidden aarni-font flex md:hidden mt-[80px]">
    <img src="assets/img/iqac/internal-banner-iqac-mobile.webp" alt="Mobile Image" class="w-full h-auto object-contain">
    <div class="absolute inset-0 flex items-center justify-center text-white text-center px-4">
        <div class="text-3xl font-bold">
            <p>INTERNAL QUALITY</p>
            <p>ASSURANCE CELL</p>
        </div>
    </div>
</div>

<section class="aarni-font text-justify">
    <div class="container mx-auto flex flex-col lg:flex-row gap-8 py-12 px-4">
        <aside class="w-full lg:w-1/4 space-y-4 lg:h-fit lg:overflow-y-auto">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Research</h2>
                    <div class="">
                        <a [href]="'/iqac/overview'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'IQAC Overview', 'text-blue-600 bg-white' : pageTitle !== 'IQAC Overview'}"
                           class="flex items-center space-x-2 p-3 w-full border-y border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>IQAC Overview</span>
                        </a>
                        <a [href]="'/iqac/aishe'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'IQAC AISHE', 'text-blue-600 bg-white' : pageTitle !== 'IQAC AISHE'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>IQAC AISHE</span>
                        </a>
                        <a [href]="'/iqac/feedback-format'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'IQAC Feedback Format', 'text-blue-600 bg-white' : pageTitle !== 'IQAC Feedback Format'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>IQAC Feedback Format</span>
                        </a>
                        <a [href]="'/iqac/awards'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'IQAC Awards', 'text-blue-600 bg-white' : pageTitle !== 'IQAC Awards'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>IQAC Awards</span>
                        </a>
                    </div>
                </div>
            </div>
            <h2 class="text-lg font-semibold mb-4 hidden lg:block">Quick Links</h2>
            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/about/faculty" class="flex items-center  space-x-3 p-2 rounded-lg">
                        <div>
                        <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Faculty</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/student-testimonial" class="flex items-center space-x-3 p-2 rounded-lg">
                        <div>
                        <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Testimonials</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/about/leadership/chancellor" class="flex items-center space-x-3 p-2 rounded-lg ">
                        <div>
            <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-phone text-2xl"></i>
            </span></div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Leadership</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/contact-us" class="flex items-center space-x-3 p-2 rounded-lg ">
                        <div>
            <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-camera text-2xl"></i>
            </span></div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Contact Us</span>
                    </a>
                </div>
            </div>
        </aside>
        <div class="flex-1 aarni-font">
            <div class="p-4 md:p-8 h-fit shadow-md bg-white">
                <h3 class="font-semibold text-[22px]">
                    {{ pageTitle }}
                </h3>
                <div *ngIf="pageTitle === 'IQAC Overview'">
                    <p class="mt-4 text-gray-700">
                        In the Year 2018, ARNI University established an Internal Quality Assurance Cell (IQAC). The vision of
                        IQAC is to align with the University Grant Commission (UGC) and National Assessment and Accreditation
                        Council (NAAC) guidelines and implement them for providing quality education. IQAC plays an important
                        role in maintaining the university framework. It is delicately focused on promoting quality education
                        enhancement and sustainability across all academic and administrative domains.
                    </p>
                    <p class="text-lg font-bold">Vision of IQAC at ARNI</p>
                    <p class="text-gray-700">
                        To encourage a diversified and dynamic environment that provides frequent improvement and excellence in
                        administrative and academic performance.
                    </p>
                    <p class="text-lg font-bold">Mission of IQAC at ARNI</p>
                    <p class="text-gray-700">
                        To create, maintain, and implement strategies to ensure the best quality and enhancement. Our mission is
                        to offer educational offerings that meet the highest standards of educational excellence on a global
                        scale.
                    </p>
                    <div class="mt-8">
                        <img alt="iqac" src="assets/img/iqac.webp" class="w-full rounded-lg object-cover"/>
                    </div>
                   <!-- <div class="bg-gray-100 py-16">
                        <h2 class="text-center text-2xl font-bold mb-6">Latest Achievements</h2>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-7xl mx-auto px-2">
                            <div class="bg-white border-2 border-yellow-500 rounded-lg p-6 shadow-lg text-center">
                                <img src="assets/img/iqac/iqac1.jpg" alt="QS I-Gauge Certificate" class="w-full h-[250px]">
                                <p class="mt-4 font-semibold">Global Prestige Awards 2024</p>
                            </div>

                            <div class="bg-white border-2 border-yellow-500 rounded-lg p-6 shadow-lg text-center">
                                <img src="assets/img/iqac/iqac2.jpg" alt="QS I-Gauge Certificate" class="w-full h-[250px]">
                                <p class="mt-4 font-semibold">Education Excellence 2024</p>
                            </div>

                            <div class="bg-white border-2 border-yellow-500 rounded-lg p-6 shadow-lg text-center">
                                <img src="assets/img/iqac/iqac3.jpg" alt="QS I-Gauge Certificate" class="w-full h-64">
                                <p class="mt-4 font-semibold">4th NTPC -National Ranking Archery Tournament 2025</p>
                            </div>
                        </div>
                    </div>-->
                    <div class="max-w-6xl lg:mx-auto border-gray-200 border mx-3 p-4 my-8">
                        <div class="space-y-4">
                            <div *ngFor="let section of sections; let i = index">
                                <button class="w-full flex items-center p-2" (click)="toggleAccordion(i)">
                                    <i class="text-lg"
                                       [ngClass]="activeIndex === i ? 'fas fa-minus text-blue-500' : 'fas fa-plus text-blue-500'"></i>
                                    <span class="ml-2 font-bold text-lg md:text-xl">{{ section.heading }}</span>
                                </button>
                                <div *ngIf="activeIndex === i" class="p-2 text-gray-700 sm:text-sm text-justify"
                                     [innerHTML]="section.content"></div>
                                <hr *ngIf="i < sections.length - 1">
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="pageTitle === 'IQAC AISHE'">
                    <div *ngFor="let item of accordionItems; let i = index"
                         class="border border-gray-300 rounded-md mb-2 overflow-hidden">
                        <div (click)="toggleAccordion(i)"
                             class="flex items-center cursor-pointer px-4 py-3 transition-colors duration-200 text-lg"
                             [ngClass]="{'text-blue-400': activeIndex === i, 'text-black': activeIndex !== i}">
      <span class="text-xl mr-3">
        {{ activeIndex === i ? '−' : '+' }}
      </span>
                            <h2 class="text-lg font-medium">
                                {{ item.title }}
                            </h2>
                        </div>

                        <div *ngIf="activeIndex === i" class="px-4 py-2 text-gray-700 border-t border-gray-200">
                            <a
                                *ngIf="item.downloadUrl && !item.openExternally"
                                href="#"
                                (click)="openPdfModal($event, item.downloadUrl)"
                                class="text-blue-600 underline mt-2 hidden lg:inline"
                            >
                                {{ item.downloadLabel }}
                            </a>
                            <a
                                [href]="'assets/pdf/' + item.pdfFileName"
                                target="_blank"
                                rel="noopener"
                                class="text-blue-600 underline cursor-pointer">
                                {{ item.description }}
                            </a>
                        </div>
                    </div>
                    <div *ngIf="pdfUrl" class="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 px-4">
                        <div class="relative w-full max-w-5xl mx-auto">
                            <div class="flex justify-end mb-2">
                                <button
                                    (click)="closePdfModal()"
                                    class="text-white text-2xl font-bold border border-white rounded-md w-10 h-10 flex items-center justify-center hover:bg-white hover:text-black transition"
                                >
                                    &times;
                                </button>
                            </div>

                            <div class="relative w-full pt-[56.25%] h-[73vh] rounded-lg shadow-lg overflow-hidden">
                                <iframe
                                    [src]="sanitizedPdfUrl"
                                    class="absolute top-0 left-0 w-full h-full"
                                    frameborder="0"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="pageTitle === 'IQAC Feedback Format'">
                    <div class="flex flex-col items-center justify-center py-10 bg-gray-50 rounded-lg shadow">
                        <h2 class="text-xl font-semibold text-gray-600">No Data Available!</h2>
                    </div>
                </div>
                <div *ngIf="pageTitle === 'IQAC Awards'">
                    <div class="flex flex-col items-center justify-center py-10 bg-gray-50 rounded-lg shadow">
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-7xl mx-auto px-2">
                            <div class="bg-white border-2 border-yellow-500 rounded-lg p-6 shadow-lg text-center">
                                <img src="assets/img/iqac/iqac1.jpg" alt="QS I-Gauge Certificate" class="w-full h-[250px]">
                                <p class="mt-4 font-semibold">Global Prestige Awards 2024</p>
                            </div>

                            <div class="bg-white border-2 border-yellow-500 rounded-lg p-6 shadow-lg text-center">
                                <img src="assets/img/iqac/iqac2.jpg" alt="QS I-Gauge Certificate" class="w-full h-[250px]">
                                <p class="mt-4 font-semibold">Education Excellence 2024</p>
                            </div>

                            <div class="bg-white border-2 border-yellow-500 rounded-lg p-6 shadow-lg text-center">
                                <img src="assets/img/iqac/iqac3.jpg" alt="QS I-Gauge Certificate" class="w-full h-64">
                                <p class="mt-4 font-semibold">4th NTPC -National Ranking Archery Tournament 2025</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
